import { render, staticRenderFns } from "./OrganizationTreeViewItem.vue?vue&type=template&id=3be89c21&"
import script from "./OrganizationTreeViewItem.vue?vue&type=script&lang=js&"
export * from "./OrganizationTreeViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports